import { ContactEnvelopePageSizeType, DepartmentType } from "@/enums/enums";
import { GetMerchantAddressModelDefault } from "@/helper/addressHelper";
import {
  GetContactEnvelopeDocumentData,
  GetContactEnvelopetPersonModelDefault,
  GetCredential,
} from "@/helper/documentFacadeHelper";
import {
  ContactEnvelopeDocumentDetailModel,
  ContactEnvelopeOnlineViewModel,
} from "@/model/document/contactEnvelopeModel";
import { CredentialModel, DocumentTemplateHeaderTypeModel } from "@/model/document/documentModel";
import { SettingContactEnvelopeDocumentTemplateModel } from "@/model/document/settingDocumentTemplate";

export function ConvertToContactEnvelopeOnlineView(detail: any): ContactEnvelopeOnlineViewModel {
  const onlineViewModel: ContactEnvelopeOnlineViewModel = new ContactEnvelopeOnlineViewModel();
  if (detail) {
    const documentDetailModel: ContactEnvelopeDocumentDetailModel = new ContactEnvelopeDocumentDetailModel();
    documentDetailModel.version = detail.document.version;
    documentDetailModel.data = GetContactEnvelopeDocumentData(detail.document.data);
    onlineViewModel.document = documentDetailModel;
    onlineViewModel.transactionId = detail.transactionId;
    onlineViewModel.transactionType = detail.transactionType;
    onlineViewModel.financeType = detail.financeType;
    onlineViewModel.expenseType = detail.expenseType;
    onlineViewModel.template = detail.template ? detail.template.data : GetContactEnvelopeSettingDocument();
    onlineViewModel.credential = detail.credential ? GetCredential(detail.credential) : new CredentialModel();
    onlineViewModel.headerOptionType = detail.headerOptionType;

    if (
      !detail.template &&
      documentDetailModel.data.contact.persons &&
      documentDetailModel.data.contact.persons.length > 0
    ) {
      if (
        documentDetailModel.data.contact.persons[0].firstName === "" &&
        documentDetailModel.data.contact.persons[0].lastName === ""
      ) {
        onlineViewModel.template.contact.isShowContactName = false;
      }
      if (documentDetailModel.data.contact.persons[0].department.departmentType === DepartmentType.None) {
        onlineViewModel.template.contact.isShowContactPosition = false;
      }
      if (documentDetailModel.data.contact.persons[0].phoneNumber === "") {
        onlineViewModel.template.contact.isShowContactTel = false;
      }
    } else {
      onlineViewModel.template.contact.isShowContactName = detail.template?.data.contact.isShowContactName ?? false;
      onlineViewModel.template.contact.isShowContactPosition =
        detail.template?.data.contact.isShowContactPosition ?? false;
      onlineViewModel.template.contact.isShowContactTel = detail.template?.data.contact.isShowContactTel ?? false;
    }
  }
  return onlineViewModel;
}

export function GetContactEnvelopeSettingDocument(): SettingContactEnvelopeDocumentTemplateModel {
  let settingTemplate = new SettingContactEnvelopeDocumentTemplateModel();

  settingTemplate = {
    pageSize: ContactEnvelopePageSizeType.A5,
    merchant: {
      merchantAddressTemplate: GetMerchantAddressModelDefault(),
      phoneNumber: {
        value: "",
        isShowElement: true,
      },
      email: {
        value: "",
        isShowElement: true,
      },
      website: {
        value: "",
        isShowElement: false,
      },
      line: {
        value: "",
        isShowElement: false,
      },
      faxNumber: {
        value: "",
        isShowElement: false,
      },
    },
    merchantLogo: {
      value: "",
      isShowElement: true,
    },
    contact: {
      personTemplate: GetContactEnvelopetPersonModelDefault(),
      isShowContactName: true,
      isShowContactPosition: true,
      isShowContactTel: true,
    },
  };

  return settingTemplate;
}

export function PrepareEnvelopeDocumentInputData(input: DocumentTemplateHeaderTypeModel) {
  const data = {
    contactId: input.transactionId,
    option: {
      documentVersion: 0,
      templateVersion: 0,
      headerOptionType: input.headerType,
      language: 1,
    },
  };
  return data;
}
